import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../components/lib/Modal';
import GlassCard from '../components/lib/GlassCard';

import { Button } from 'hosman-material';

import { updateNoResultsModalOpen } from '../../../../../reducers/_Pages/Public/radarSlice';

const NoResultsModal = () => {
  const { noResultsModalOpen } = useSelector((state) => state.radar);
  const dispatch = useDispatch();

  return (
    <Modal isOpen={noResultsModalOpen} closeModal={() => dispatch(updateNoResultsModalOpen(false))}>
      <GlassCard hoverBgColor='' width='w-full md:w-96'>
        <div className='flex flex-col gap-6 p-4 text-center'>
          <div className='flex flex-col gap-3'>
            <p className='text-ih-blue h3'>Silence radio.<br />Rien à signaler par ici !</p>
            <p>Elargissez la zone de recherche de radar, ou changez la position de celui-ci.</p>
          </div>

          <Button label='Nouvelle recherche' onClick={() => dispatch(updateNoResultsModalOpen(false))} />
        </div>
      </GlassCard>
    </Modal>
  )
}

export default NoResultsModal;
